import { Box } from '@mui/material';
import moment from 'moment';
import * as React from 'react';

import { People } from '~/services/Http';

import { selectAbsenceColor } from '../../../../../../../../utils';

import { useSxStyles } from './useStyles';

export interface Props {
  day: moment.Moment;
  absences: People.AbsenceDto[];
  publicHolidays?: People.PublicHolidayDto[];
  endOfRange: moment.Moment;
}

const absenceContent = (
  absenceStatus: string,
  absenceType: string,
  absenceEnd: Date | undefined,
) => {
  let contentSymbol = '';
  if (absenceStatus !== People.AbsenceStatusEnum.APPROVED) {
    contentSymbol += '?';
  }
  if (absenceType === People.AbsenceTypeEnum.LONG) {
    contentSymbol += 'L';
  }

  if (absenceEnd === null) {
    if (contentSymbol === '?L') {
      contentSymbol = '?★';
    } else {
      contentSymbol += '★';
    }
  }

  return contentSymbol;
};

export const CalendarCell: React.FC<Props> = ({
  day,
  absences,
  publicHolidays,
  endOfRange,
}) => {
  const sxStyles = useSxStyles();

  const absence = React.useMemo(() => {
    return absences.find(
      (absence) =>
        moment(day).isBetween(
          moment(absence.startDate),
          moment(absence.endDate),
          'day',
          '[]',
        ) ||
        moment(day)
          .format('DD-MM-YYYY')
          .match(moment(absence.startDate).format('DD-MM-YYYY')),
    );
  }, [absences, day]);

  const publicHoliday = React.useMemo(() => {
    return publicHolidays?.find((publicHoliday) => {
      return (
        moment(day)
          .format('DD-MM-YYYY')
          .match(moment(publicHoliday.date).format('DD-MM-YYYY')) &&
        Number(publicHoliday.legalEntityId) ===
          absences[0].employee.legalEntity?.id
      );
    });
  }, [publicHolidays, day, absences]);

  if (publicHoliday) {
    return (
      <Box sx={{ ...sxStyles.default, ...sxStyles.publicHoliday }}>
        <Box component="span" sx={sxStyles.content}>
          PH
        </Box>
      </Box>
    );
  }

  if (absence) {
    return (
      <Box
        sx={{
          ...sxStyles.default,
          backgroundColor: selectAbsenceColor(
            absence.reason.code,
            absence.reason.value,
          ),
        }}
      >
        <Box component="span" sx={sxStyles.content}>
          {absenceContent(absence.status.code, absence.type, absence.endDate)}
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        ...sxStyles.default,
        ...(day.isAfter(endOfRange, 'day') && sxStyles.endOfRange),
      }}
    ></Box>
  );
};
